import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-event-restreaming-services` v1 — the restreaming
 * pirate services detected for one published protected-event report edition.
 * Ranked by the caller (typically by estimated audience); this widget only
 * renders the order it is given.
 */
export const EVENT_RESTREAMING_SERVICES_CONTRACT: WidgetDataContract = {
  name: "protection-overview-event-restreaming-services",
  version: 1,
};

export interface EventRestreamingService {
  id: string;
  label: string;
  distinctIps: number;
  /** Fraction of distinct IPs sitting behind a safe (blockable) ISP, 0-1. */
  safeIpPct: number;
  approxAudience: number;
  estimatedAudience: number;
  /** Fraction of estimated audience removed by blocking/takedown action, 0-1. */
  audienceReductionPct: number;
}

export interface EventRestreamingServicesFreshness {
  generatedAt: string;
  dataThrough: string;
  source: string;
  isEstimated: boolean;
}

export interface EventRestreamingServicesHeader {
  id: string;
  label: string;
  campaign: { id: string; label: string };
  /** The tenant this event's campaign belongs to, when known. */
  tenant?: { id: number; label: string };
}

export interface EventRestreamingServicesData {
  services: EventRestreamingService[];
  freshness: EventRestreamingServicesFreshness;
  /** Only used to climb the drill-down breadcrumb — not rendered by the card grid itself. */
  event?: EventRestreamingServicesHeader;
}
